import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaCheck, FaDownload, FaPlay, FaChevronDown, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { SEO } from '../../components/SEO';
import { FaCheckCircle, FaFileAlt, FaChartLine, FaBriefcase, FaBuilding, FaUniversity } from 'react-icons/fa';
import BrandText from '../../styles/brandStyles';
// import mejoraExportarPdf from '../../assets/images/opus_m1/01 mejora exportar a pdf.png';
// import mejoraDistTabla from '../../assets/images/opus_m1/02 mejora dist en tabla.png';
// import sabanaEstimaciones from '../../assets/images/opus_m1/03 SABANA ESTIMACIONES.png';
// import mejoraCargaRecursos from '../../assets/images/opus_m1/04 MEJORA CARGA DE RECURSOS.png';
// import aspecto1 from '../../assets/images/opus_m1/04_aspecto-1.png';
// import mejoraComparativo from '../../assets/images/opus_m1/05 MEJORA comparativo.png';
// import mejoraMatrics from '../../assets/images/opus_m1/06 MEJORA matrics donde se usa.png';
// import mejoraCopiaEncabezados from '../../assets/images/opus_m1/08 MEJORA copia con encabezados(1).png';
// import mejoraCasillaMarcado from '../../assets/images/opus_m1/09 MEJORA casilla de marcado seleccin reportes.png';
// import mejoraImpresionReportes from '../../assets/images/opus_m1/10 MEJORA impresion reportes completo parcial seleccion(1).png';
// import analisisN from '../../assets/images/opus_m1/analisisN.png';
// import aspectoComportamiento from '../../assets/images/opus_m1/aspecto y comportamiento.png';
// import valorGanado2 from '../../assets/images/opus_m1/valor ganado2.png';

const PresupuestoProgramable = () => {
  const { translate } = useLanguage();
  const [activeSection, setActiveSection] = useState('overview');
  const [isSticky, setIsSticky] = useState(false);
  
  // Estados para controlar los carruseles
  const [activeCard1, setActiveCard1] = useState(0);
  const [activeCard2, setActiveCard2] = useState(0);
  const [activeCard3, setActiveCard3] = useState(0);

  // Helper function to scroll to top when navigating to a new page
  const scrollToTop = () => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'auto'
      });
    }, 0);
  };

  // Reset scroll position when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Add event listener for navigation changes
    const handleNavigation = () => {
      window.scrollTo({
        top: 0,
        behavior: 'auto'
      });
    };
    
    // Listen for navigation events
    window.addEventListener('popstate', handleNavigation);
    
    return () => {
      window.removeEventListener('popstate', handleNavigation);
    };
  }, []);

  // Datos para los carruseles con rutas actualizadas a imágenes en public/images/modules/opus_m1
  const carouselData1 = [
    {
      image: "/images/modules/opus_m1/01 mejora exportar a pdf.png",
      title: "Elabora presupuestos detallados",
      description: "Crea presupuestos completos con desglose de conceptos, análisis de precios unitarios y estimaciones de costos. Utiliza catálogos de recursos actualizables y matrices de precios para mayor precisión.",
      features: [
        "Desglose detallado de conceptos y partidas",
        "Análisis de precios unitarios completos",
        "Catálogos de recursos personalizables"
      ],
      link: "/caracteristicas/presupuestos-detallados"
    },
    {
      image: "/images/modules/opus_m1/02 mejora dist en tabla.png",
      title: "Presupuestos avanzados con BIM",
      description: "Integra tus presupuestos con modelos BIM para una estimación más precisa. Extrae cantidades directamente de modelos 3D y actualiza automáticamente tus presupuestos cuando el diseño cambia.",
      features: [
        "Integración con modelos BIM",
        "Extracción automática de cantidades",
        "Actualización en tiempo real"
      ],
      link: "/caracteristicas/presupuestos-bim"
    },
    {
      image: "/images/modules/opus_m1/03 SABANA ESTIMACIONES.png",
      title: "Presupuestos colaborativos",
      description: "Trabaja en equipo con múltiples usuarios en el mismo presupuesto. Controla permisos, gestiona versiones y mantén un historial de cambios para una colaboración eficiente.",
      features: [
        "Trabajo simultáneo de múltiples usuarios",
        "Control de versiones y cambios",
        "Comentarios y anotaciones en tiempo real"
      ],
      link: "/caracteristicas/presupuestos-colaborativos"
    }
  ];

  const carouselData2 = [
    {
      image: "/images/modules/opus_m1/04 MEJORA CARGA DE RECURSOS.png",
      title: "Programa actividades de obra",
      description: "Desarrolla cronogramas detallados con diagramas de Gantt, identifica la ruta crítica y optimiza la programación de actividades para cumplir con los plazos establecidos.",
      features: [
        "Diagramas de Gantt interactivos",
        "Análisis de ruta crítica",
        "Programación de recursos y suministros"
      ],
      link: "/caracteristicas/programacion-obra"
    },
    {
      image: "/images/modules/opus_m1/04_aspecto-1.png",
      title: "Gestión de recursos",
      description: "Optimiza la asignación de recursos humanos y materiales. Visualiza la carga de trabajo, identifica cuellos de botella y equilibra la distribución de recursos para maximizar la eficiencia.",
      features: [
        "Asignación inteligente de recursos",
        "Visualización de carga de trabajo",
        "Optimización de recursos disponibles"
      ],
      link: "/caracteristicas/gestion-recursos"
    },
    {
      image: "/images/modules/opus_m1/05 MEJORA comparativo.png",
      title: "Análisis de escenarios",
      description: "Evalúa diferentes escenarios de programación para encontrar la solución óptima. Simula cambios en plazos, recursos y dependencias para tomar decisiones informadas.",
      features: [
        "Simulación de múltiples escenarios",
        "Análisis de impacto de cambios",
        "Optimización basada en objetivos"
      ],
      link: "/caracteristicas/analisis-escenarios"
    }
  ];

  const carouselData3 = [
    {
      image: "/images/modules/opus_m1/06 MEJORA matrics donde se usa.png",
      title: "Analiza costos y rendimientos",
      description: "Evalúa el rendimiento de recursos, compara costos históricos y realiza proyecciones financieras para tomar decisiones informadas sobre tus proyectos.",
      features: [
        "Análisis de rendimiento de recursos",
        "Comparación de costos históricos",
        "Proyecciones financieras y flujos de efectivo"
      ],
      link: "/caracteristicas/analisis-costos"
    },
    {
      image: "/images/modules/opus_m1/08 MEJORA copia con encabezados(1).png",
      title: "Control de desviaciones",
      description: "Identifica y analiza desviaciones entre lo presupuestado y lo ejecutado. Visualiza tendencias, detecta patrones y toma acciones correctivas antes de que los problemas se agraven.",
      features: [
        "Detección temprana de desviaciones",
        "Análisis de causas raíz",
        "Recomendaciones de acciones correctivas"
      ],
      link: "/caracteristicas/control-desviaciones"
    },
    {
      image: "/images/modules/opus_m1/09 MEJORA casilla de marcado seleccin reportes.png",
      title: "Análisis predictivo",
      description: "Utiliza datos históricos y algoritmos avanzados para predecir costos futuros, identificar riesgos potenciales y optimizar la asignación de recursos para proyectos futuros.",
      features: [
        "Predicción de costos futuros",
        "Identificación de riesgos potenciales",
        "Optimización basada en datos históricos"
      ],
      link: "/caracteristicas/analisis-predictivo"
    }
  ];

  // Función para manejar el scroll y actualizar la sección activa
  useEffect(() => {
    const handleScroll = () => {
      // Detectar si el submenú debe ser sticky
      const heroSection = document.getElementById('overview');
      const headerHeight = 64; // Altura del header principal
      
      if (heroSection) {
        const heroBottom = heroSection.getBoundingClientRect().bottom;
        setIsSticky(heroBottom <= headerHeight);
      } else {
        // Si no se encuentra la sección, mantener el menú sticky para evitar que desaparezca
        setIsSticky(true);
      }

      // Detectar qué sección está visible
      const sections = ['overview', 'features', 'capabilities', 'benefits', 'cta'];
      let activeFound = false;
      
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          const offset = 140; // Altura del header + submenu
          if (rect.top <= offset && rect.bottom >= offset) {
            setActiveSection(section);
            activeFound = true;
            break;
          }
        }
      }
      
      // Si no se encuentra ninguna sección activa, mantener la última activa
      if (!activeFound && window.scrollY > 0) {
        // Mantener la sección activa anterior o establecer una por defecto
        setIsSticky(true);
      }
    };

    // Ejecutar handleScroll inmediatamente para establecer el estado inicial
    handleScroll();
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Función para hacer scroll a una sección
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 140; // Altura del header + submenu
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  // Funciones para navegar entre las tarjetas
  const nextCard = (setActiveCard, activeCard, maxCards) => {
    setActiveCard((activeCard + 1) % maxCards);
  };

  const prevCard = (setActiveCard, activeCard, maxCards) => {
    setActiveCard((activeCard - 1 + maxCards) % maxCards);
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="OPUS - Módulo 1: Presupuesto Programable | ECOSOFT"
        description="Elabora presupuestos detallados y programaciones de obra con el módulo base de OPUS, el sistema líder en ingeniería de costos."
        keywords="OPUS, presupuestos, programación de obra, ingeniería de costos, precio unitario"
      />
      
      {/* Hero Section */}
      <section id="overview" className="relative h-[450px] bg-gradient-to-r from-[#003171] to-[#0066CC]" style={{
        backgroundImage: 'url("/images/modules/opus_m1/cabecera_m1.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        <div className="absolute inset-0 bg-black/70"></div>
        <div className="container mx-auto px-4 h-full flex items-center pt-12 relative z-10">
          <div className="max-w-2xl text-white">
            <div className="flex items-center mb-6">
              <div className="relative w-32 h-32 mr-6 flex-shrink-0">
                <div className="absolute inset-[5%] bg-white rounded-full"></div>
                <img 
                  src="/images/m1.svg" 
                  alt="Módulo 1" 
                  className="w-full h-full relative z-10"
                />
              </div>
              <div className="flex flex-col justify-center">
                <h1 className="text-5xl font-bold">OPUS M1</h1>
                <h2 className="text-4xl font-bold mt-2">Presupuesto Programable</h2>
              </div>
            </div>
            <p className="text-xl mb-8">
              Software especializado para la elaboración y control de presupuestos en proyectos de construcción.
            </p>
            <div className="flex gap-4">
              <Link to="/soporte/descargas" className="bg-white text-[#0066CC] px-8 py-3 rounded-md font-semibold hover:bg-gray-100 transition-colors" onClick={scrollToTop}>
                Descargar
              </Link>
              <Link to="/Distribuidores" className="border-2 border-white text-white px-8 py-3 rounded-md font-semibold hover:bg-white/10 transition-colors" onClick={scrollToTop}>
                Ver demostración
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      {/* Submenu Navigation */}
      <div 
        className={`bg-white shadow-md transition-all duration-300 sticky-nav ${
          isSticky 
            ? 'fixed top-[64px] left-0 right-0 z-30 border-t border-gray-200' 
            : 'relative'
        }`}
        style={{ minHeight: '56px' }} // Altura mínima para evitar saltos
      >
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="flex overflow-x-auto py-4 items-center relative">
            <div className="flex-grow flex">
              <button 
                onClick={() => scrollToSection('overview')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'overview' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Resumen
              </button>
              <button 
                onClick={() => scrollToSection('features')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'features' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Características
              </button>
              <button 
                onClick={() => scrollToSection('capabilities')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'capabilities' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Capacidades
              </button>
              <button 
                onClick={() => scrollToSection('benefits')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'benefits' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Beneficios
              </button>
              <button 
                onClick={() => scrollToSection('cta')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'cta' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Comenzar
              </button>
            </div>
            <div className="flex items-center ml-4">
              <img 
                src="/images/m1.svg" 
                alt="Módulo 1 - Presupuesto Programable" 
                className="h-12 w-auto"
              />
            </div>
          </div>
        </div>
      </div>
      
      {/* Features Grid */}
      <section id="features" className="py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Videos */}
            <div className="bg-gray-50 p-6 rounded-lg flex flex-col h-full">
              <div className="w-10 h-10 bg-[#0066CC]/10 rounded-lg flex items-center justify-center mb-4">
                <FaPlay className="w-5 h-5 text-[#0066CC]" />
              </div>
              <h3 className="text-lg font-semibold mb-1">VIDEOS</h3>
              <h4 className="text-base font-medium mb-2">Canal oficial</h4>
              <p className="text-gray-600 mb-4 flex-grow text-sm">
                Consulta el canal oficial y descubre todo lo que OPUS tiene para tí.
              </p>
              <Link to="/academia-opus" className="text-[#0066CC] font-medium inline-flex items-center text-sm" onClick={scrollToTop}>
                Ver ahora <FaArrowRight className="ml-2" />
              </Link>
            </div>

            {/* Más Información */}
            <div className="bg-gray-50 p-6 rounded-lg flex flex-col h-full">
              <div className="w-10 h-10 bg-[#0066CC]/10 rounded-lg flex items-center justify-center mb-4">
                <FaFileAlt className="w-5 h-5 text-[#0066CC]" />
              </div>
              <h3 className="text-lg font-semibold mb-1">MÁS INFORMACIÓN</h3>
              <h4 className="text-base font-medium mb-2">Folleto</h4>
              <p className="text-gray-600 mb-4 flex-grow text-sm">
                Información detallada acerca de las nuevas herramientas y todas las prestaciones del sistema.
              </p>
              <a href="/documents/OPUS25_M1.pdf" download className="text-[#0066CC] font-medium inline-flex items-center text-sm" onClick={scrollToTop}>
                Descarga <FaDownload className="ml-2" />
              </a>
            </div>

            {/* Conoce a Fondo */}
            <div className="bg-gray-50 p-6 rounded-lg flex flex-col h-full">
              <div className="w-10 h-10 bg-[#0066CC]/10 rounded-lg flex items-center justify-center mb-4">
                <FaChartLine className="w-5 h-5 text-[#0066CC]" />
              </div>
              <h3 className="text-lg font-semibold mb-1">CONOCE A FONDO</h3>
              <h4 className="text-base font-medium mb-2">Deseo una demostración</h4>
              <p className="text-gray-600 mb-4 flex-grow text-sm">
                Agenda una presentación personalizada con nuestros expertos.
              </p>
              <Link to="/Distribuidores" className="text-[#0066CC] font-medium inline-flex items-center text-sm" onClick={scrollToTop}>
                Contáctanos <FaArrowRight className="ml-2" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Capabilities Section - Similar to "What you can do with Autodesk Revit" */}
      <section id="capabilities" className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-3">Lo que puedes hacer con OPUS M1</h2>
          <p className="text-xl text-gray-600 text-center mb-10 max-w-3xl mx-auto">
            Descubre cómo OPUS M1 te ayuda a crear presupuestos precisos y gestionar proyectos de construcción de manera eficiente.
          </p>
          
          <div className="space-y-12">
            {/* Capability 1 */}
            <div className="flex flex-col md:flex-row gap-6 items-center">
              <div className="w-full md:w-1/2 relative group">
                <img 
                  src={carouselData1[activeCard1].image} 
                  alt={carouselData1[activeCard1].title} 
                  className="rounded-lg shadow-lg w-full h-72 object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-between px-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button 
                    onClick={() => prevCard(setActiveCard1, activeCard1, carouselData1.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Anterior"
                  >
                    <FaChevronLeft size={20} />
                  </button>
                  <button 
                    onClick={() => nextCard(setActiveCard1, activeCard1, carouselData1.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Siguiente"
                  >
                    <FaChevronRight size={20} />
                  </button>
                </div>
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 bg-white/80 px-3 py-1 rounded-full">
                  {carouselData1.map((_, index) => (
                    <button 
                      key={index}
                      onClick={() => setActiveCard1(index)}
                      className={`w-2.5 h-2.5 rounded-full transition-colors ${index === activeCard1 ? 'bg-[#0066CC]' : 'bg-gray-300 hover:bg-gray-400'}`}
                      aria-label={`Ir a diapositiva ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <h3 className="text-2xl font-bold mb-3">{carouselData1[activeCard1].title}</h3>
                <p className="text-gray-600 mb-3">
                  {carouselData1[activeCard1].description}
                </p>
                <ul className="space-y-2 mb-4">
                  {carouselData1[activeCard1].features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <FaCheck className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            
            {/* Capability 2 */}
            <div className="flex flex-col md:flex-row-reverse gap-6 items-center">
              <div className="w-full md:w-1/2 relative group">
                <img 
                  src={carouselData2[activeCard2].image} 
                  alt={carouselData2[activeCard2].title} 
                  className="rounded-lg shadow-lg w-full h-72 object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-between px-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button 
                    onClick={() => prevCard(setActiveCard2, activeCard2, carouselData2.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Anterior"
                  >
                    <FaChevronLeft size={20} />
                  </button>
                  <button 
                    onClick={() => nextCard(setActiveCard2, activeCard2, carouselData2.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Siguiente"
                  >
                    <FaChevronRight size={20} />
                  </button>
                </div>
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 bg-white/80 px-3 py-1 rounded-full">
                  {carouselData2.map((_, index) => (
                    <button 
                      key={index}
                      onClick={() => setActiveCard2(index)}
                      className={`w-2.5 h-2.5 rounded-full transition-colors ${index === activeCard2 ? 'bg-[#0066CC]' : 'bg-gray-300 hover:bg-gray-400'}`}
                      aria-label={`Ir a diapositiva ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <h3 className="text-2xl font-bold mb-3">{carouselData2[activeCard2].title}</h3>
                <p className="text-gray-600 mb-3">
                  {carouselData2[activeCard2].description}
                </p>
                <ul className="space-y-2 mb-4">
                  {carouselData2[activeCard2].features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <FaCheck className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            
            {/* Capability 3 */}
            <div className="flex flex-col md:flex-row gap-6 items-center">
              <div className="w-full md:w-1/2 relative group">
                <img 
                  src={carouselData3[activeCard3].image} 
                  alt={carouselData3[activeCard3].title} 
                  className="rounded-lg shadow-lg w-full h-72 object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-between px-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button 
                    onClick={() => prevCard(setActiveCard3, activeCard3, carouselData3.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Anterior"
                  >
                    <FaChevronLeft size={20} />
                  </button>
                  <button 
                    onClick={() => nextCard(setActiveCard3, activeCard3, carouselData3.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Siguiente"
                  >
                    <FaChevronRight size={20} />
                  </button>
                </div>
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 bg-white/80 px-3 py-1 rounded-full">
                  {carouselData3.map((_, index) => (
                    <button 
                      key={index}
                      onClick={() => setActiveCard3(index)}
                      className={`w-2.5 h-2.5 rounded-full transition-colors ${index === activeCard3 ? 'bg-[#0066CC]' : 'bg-gray-300 hover:bg-gray-400'}`}
                      aria-label={`Ir a diapositiva ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <h3 className="text-2xl font-bold mb-3">{carouselData3[activeCard3].title}</h3>
                <p className="text-gray-600 mb-3">
                  {carouselData3[activeCard3].description}
                </p>
                <ul className="space-y-2 mb-4">
                  {carouselData3[activeCard3].features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <FaCheck className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Benefits */}
      <section id="benefits" className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-8">Beneficios clave</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-6 h-6 rounded-full bg-[#0066CC] flex items-center justify-center mt-1 mr-4">
                  <FaCheck className="text-white text-sm" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-1">Mayor precisión</h3>
                  <p className="text-gray-600">
                    Reduce errores y discrepancias en los presupuestos con herramientas especializadas.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 rounded-full bg-[#0066CC] flex items-center justify-center mt-1 mr-4">
                  <FaCheck className="text-white text-sm" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-1">Ahorro de tiempo</h3>
                  <p className="text-gray-600">
                    Automatiza cálculos y procesos repetitivos para mayor eficiencia.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 rounded-full bg-[#0066CC] flex items-center justify-center mt-1 mr-4">
                  <FaCheck className="text-white text-sm" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-1">Mejor control</h3>
                  <p className="text-gray-600">
                    Mantén un seguimiento detallado de todos los aspectos del presupuesto.
                  </p>
                </div>
              </div>
            </div>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-6 h-6 rounded-full bg-[#0066CC] flex items-center justify-center mt-1 mr-4">
                  <FaCheck className="text-white text-sm" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-1">Colaboración mejorada</h3>
                  <p className="text-gray-600">
                    Trabaja en equipo con acceso simultáneo y control de versiones.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 rounded-full bg-[#0066CC] flex items-center justify-center mt-1 mr-4">
                  <FaCheck className="text-white text-sm" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-1">Reportes avanzados</h3>
                  <p className="text-gray-600">
                    Genera informes detallados y personalizados para análisis y presentaciones.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 rounded-full bg-[#0066CC] flex items-center justify-center mt-1 mr-4">
                  <FaCheck className="text-white text-sm" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-1">Integración completa</h3>
                  <p className="text-gray-600">
                    Se integra con otros módulos OPUS para un flujo de trabajo unificado.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Integration with other modules */}
      <section className="py-16 bg-[#F5F7FA]">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-8 text-[#1A2B39]">Integración con otros módulos</h2>
          <p className="text-center text-gray-600 mb-12 max-w-3xl mx-auto">
            El Módulo 1 se integra perfectamente con el resto de OPUS para ofrecer una solución completa
          </p>
          
          <div className="grid md:grid-cols-5 gap-6 max-w-5xl mx-auto">
            <Link to="/modulos/presupuesto-programable" className="bg-[#F5F7FA] p-5 rounded-lg text-center border-2 border-[#0066CC] hover:bg-[#0066CC]/5 transition-colors" onClick={scrollToTop}>
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 1</h3>
              <p className="text-gray-600 text-sm">Presupuesto Programable</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
            
            <Link to="/modulos/planeacion-control" className="bg-[#F5F7FA] p-5 rounded-lg text-center hover:bg-[#0066CC]/5 transition-colors" onClick={scrollToTop}>
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 2</h3>
              <p className="text-gray-600 text-sm">Planeación y Control</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
            
            <Link to="/modulos/administracion-compras" className="bg-[#F5F7FA] p-5 rounded-lg text-center hover:bg-[#0066CC]/5 transition-colors" onClick={scrollToTop}>
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 3</h3>
              <p className="text-gray-600 text-sm">Administración de Compras</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
            
            <Link to="/modulos/dependencias" className="bg-[#F5F7FA] p-5 rounded-lg text-center hover:bg-[#0066CC]/5 transition-colors" onClick={scrollToTop}>
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 4</h3>
              <p className="text-gray-600 text-sm">Dependencias</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
            
            <Link to="/modulos/cuantificacion-bim" className="bg-[#F5F7FA] p-5 rounded-lg text-center hover:bg-[#0066CC]/5 transition-colors" onClick={scrollToTop}>
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 5</h3>
              <p className="text-gray-600 text-sm">Cuantificación BIM</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
          </div>
        </div>
      </section>

      {/* Cursos y CERTIFICADOS */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-8 text-[#1A2B39]">Cursos y Certificados</h2>
          <p className="text-center text-gray-600 mb-12 max-w-3xl mx-auto">
            Fortalece tus conocimientos en OPUS Presupuesto Programable con nuestro programa de certificación
          </p>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaUniversity className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Curso básico</h3>
              <p className="text-gray-600 mb-4 text-center">
                Aprende los fundamentos para elaborar presupuestos completos y programas de obra
              </p>
              <Link 
                to="/certificaciones" 
                className="block text-center px-6 py-2 bg-[#0066CC] text-white rounded-md hover:bg-[#0055AA] transition-colors mx-auto w-full"
                onClick={scrollToTop}
              >
                Ver detalles
              </Link>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaFileAlt className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Curso avanzado</h3>
              <p className="text-gray-600 mb-4 text-center">
                Domina técnicas avanzadas de presupuestación y optimización de recursos
              </p>
              <Link 
                to="/certificaciones" 
                className="block text-center px-6 py-2 bg-[#0066CC] text-white rounded-md hover:bg-[#0055AA] transition-colors mx-auto w-full"
                onClick={scrollToTop}
              >
                Ver detalles
              </Link>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaBriefcase className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Certificación oficial</h3>
              <p className="text-gray-600 mb-4 text-center">
                Obtén la certificación oficial ECOSOFT que valida tus conocimientos profesionales
              </p>
              <Link 
                to="/certificaciones" 
                className="block text-center px-6 py-2 bg-[#0066CC] text-white rounded-md hover:bg-[#0055AA] transition-colors mx-auto w-full"
                onClick={scrollToTop}
              >
                Ver detalles
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="cta" className="py-16 bg-[#1A2B39] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">¿Listo para llevar tus presupuestos al siguiente nivel?</h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Descubre todo el potencial de OPUS M1 Presupuesto Programable para optimizar la gestión de tus proyectos.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link 
              to="/soporte/descargas" 
              className="px-8 py-3 bg-[#0066CC] hover:bg-[#0088FF] text-white font-medium rounded-md transition-colors"
              onClick={scrollToTop}
            >
              Descargar
            </Link>
            <Link 
              to="/Distribuidores" 
              className="px-8 py-3 border border-white hover:bg-white hover:text-[#1A2B39] text-white font-medium rounded-md transition-colors"
              onClick={scrollToTop}
            >
              Solicitar demostración
            </Link>
            <Link 
              to="/Distribuidores" 
              className="px-8 py-3 bg-white text-[#1A2B39] hover:bg-gray-100 font-medium rounded-md transition-colors"
              onClick={scrollToTop}
            >
              Contactar con ventas
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PresupuestoProgramable; 